import { Paper } from "@material-ui/core";
import { observer } from "mobx-react";
import * as React from "react";
import { t } from "../../../i18n/util";
import { hrStore } from "../../../stores/HrStore";
import { HistoryLine, SectionHeaderSmall } from "../../ui/Primitives";
import { historyToApplicantPicture } from "../../util/helpers";

export const ApplicantHistorySite = observer(() => (
    <Paper style={{ padding: 24 }}>
        <SectionHeaderSmall label={t("screen.applicantDetails.history")} style={{ marginBottom: 20 }} />
        {hrStore.currentApplicant.history
            ?.slice()
            .reverse()
            ?.map((history, index) => (
                <HistoryLine
                    key={index}
                    history={history}
                    name={`${hrStore.currentApplicant.firstName} ${hrStore.currentApplicant.lastName}`}
                    applicantPicture={historyToApplicantPicture(history, hrStore.currentApplicant)}
                />
            ))}
    </Paper>
));
